import { yupResolver } from "@hookform/resolvers/yup";
import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import * as Yup from "yup";
import { LOGIN_URLS } from "../../api/LoginUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { post } from "../../services/smartApiService";

// Validation Schema
const schema = Yup.object({
  epassword: Yup.string().required("Password Required"),
  emailid: Yup.string()
    .required("Email is required")
    .email("Please enter a valid email"),
});

const TrainerLogin: React.FC = () => {
  const navigate = useNavigate();
  const { setUser } = useSiteContext();
  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const handleLogin = async (data: any) => {
    let url = LOGIN_URLS.LOGIN;
    const subscription = post(url, data, {
      requiresAuthorization: false,
    }).subscribe((response) => {
      reset();
      setUser(response.data);
      navigate("admin/dashboard-trainer")
    });

    return () => {
      subscription.unsubscribe();
    };
   
  };


  const formElements: SdsFormElementProps[] = [
    {
      type: "TEXT_BOX",
      width: 12,
      name: "emailid",
      element: {
        label: "Email",
        isRequired: true,
        // placeHolder: "Email ",
        max: 255,
        // inputType: "BORDER_LABEL_FOCUS",
        leftIcon: "fa fa-envelope-square",
      },
    },
    {
      type: "PASSWORD",
      width: 12,
      name: "epassword",
      element: {
        label: "Password",
        isRequired: true,
        // placeHolder: "Password",
        // inputType: "BORDER_LABEL_FOCUS",
        leftIcon: "fa fa-lock",
      },
    },
    {
      type: "BUTTON",
      width: 12,
      name: "submitbutton",
      element: {
        label: "Login",
        onClick: handleSubmit(handleLogin),
        classList: ["smart-action-button is-link"],
      },
    },
  ];


  return (
    <div className="login-form">
      <div className="smart-elf-login-input has-text-black">
        <SdsForm
          elements={formElements}
          errors={errors}
          control={control}
        />
      </div>
    </div>
  );
};

export default TrainerLogin;